<div
  class="dock"
  cdkDrag
  cdkDragLockAxis="x"
  cdkDragBoundary="tellent-assistant-chat-panel"
  [cdkDragDisabled]="expanded() || embedded()"
  [cdkDragFreeDragPosition]="dragPosition()"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragMoved)="onDragMoved()"
  (cdkDragEnded)="onDragEnded($event)"
>
  <div class="window">
    <div class="shell">
      @if (expanded()) {
        <tellent-assistant-thread-drawer
          class="drawer drawer-inline"
          [threads]="threadsService.threads()"
          [activeId]="assistantService.currentThreadId()"
          [isDeleting]="isDeleting"
          (newThread)="newThread()"
          (selectThread)="selectThread($event)"
          (deleteThread)="deleteThread($event)"
          (pinThread)="threadsService.setThreadPinned($event.id, $event.pinned)"
          (helpCenter)="openHelpCenter()"
          (intelligenceSettings)="openIntelligenceSettings()"
        />
      }

      <section class="main">
        <tellent-assistant-header
          cdkDragHandle
          [title]="title()"
          [inThread]="assistantService.messages().length > 0"
          [expanded]="expanded()"
          [minimized]="minimized()"
          [pinned]="currentThreadPinned()"
          [windowControls]="!embedded()"
          (headerClick)="onHeaderClick()"
          (menu)="drawerOpen.set(!drawerOpen())"
          (newChat)="newThread()"
          (close)="close.emit()"
          (minimize)="minimize.emit()"
          (restore)="restore.emit()"
          (expand)="expand.emit()"
          (collapse)="collapse.emit()"
          (pinThread)="togglePin()"
        />

        <div class="body" #bodyScroll (scroll)="onBodyScroll()">
          @if (assistantService.messages().length === 0) {
            @if (threadsService.currentThreadLoading()) {
              <div class="thread-loading">
                <rt-spinner />
              </div>
            } @else {
              <tellent-assistant-empty-state
                [userName]="config.userName()"
                [suggestions]="config.suggestions()"
                [loading]="false"
                [expanded]="expanded()"
                (suggestionClick)="sendStarter($event)"
              />
            }
          } @else {
            <div class="messages">
              @for (msg of assistantService.messages(); track msg.id) {
                <tellent-assistant-message
                  [message]="msg"
                  [pending]="$last && assistantService.runStatus() === 'running'"
                  [resolveRenderComponent]="resolveRenderComponent"
                  [renderToolNames]="renderToolNames"
                  [toolTitles]="toolTitles()"
                  [actionResolver]="actionResolver"
                  [resultLinkResolver]="resultLinkResolver"
                  [decisionBusyResolver]="decisionBusyResolver"
                  [decisionErrorResolver]="decisionErrorResolver"
                  (proposalDecided)="onProposalDecided($event)"
                />
              }
              <div #scrollSpacer class="scroll-spacer"></div>
            </div>
          }
        </div>

        @if (assistantService.messages().length > 0) {
          <div class="scroll-fade" [class.at-bottom]="atBottom()" aria-hidden="true"></div>
        }

        <tellent-assistant-input
          [busy]="assistantService.runStatus() === 'running'"
          (send)="send($event)"
          (stop)="assistantService.cancelRun()"
        />

        <p class="disclaimer">
          {{ 'tlc.tellent_assistant.chat_panel.disclaimer_text' | translate }}
          <a href="https://support.tellent.com/ai" target="_blank" rel="noopener">
            {{ 'tlc.tellent_assistant.chat_panel.disclaimer_link' | translate }}
          </a>
        </p>
      </section>

      @if (!expanded() && !minimized()) {
        @if (headerRef()?.menuTriggerOrigin(); as menuOrigin) {
          <ng-template
            #drawerOverlay="rtConnectedOverlay"
            rt-connected-overlay
            [origin]="menuOrigin"
            [positions]="drawerPositions"
            [offsetY]="4"
            [rtConnectedOverlayAutoClose]="false"
            [open]="drawerOpen()"
            hasBackdrop
            withOverlayLevel
            (backdropClick)="drawerOpen.set(false)"
            (attach)="onDrawerAttach()"
          >
            <tellent-assistant-thread-drawer
              class="drawer drawer-popover"
              [threads]="threadsService.threads()"
              [activeId]="assistantService.currentThreadId()"
              [isDeleting]="isDeleting"
              (newThread)="newThread(); drawerOpen.set(false)"
              (selectThread)="selectThread($event); drawerOpen.set(false)"
              (deleteThread)="deleteThread($event)"
              (pinThread)="threadsService.setThreadPinned($event.id, $event.pinned)"
              (helpCenter)="openHelpCenter()"
              (intelligenceSettings)="openIntelligenceSettings()"
            />
          </ng-template>
        }
      }
    </div>
  </div>
</div>
